import { FC } from 'react';
import X4Model from './X4Model/X4Model';
import E4Model from './E4Model/E4Model';
import X6Model from './X6Model/X6Model';
import MissingModel from './MissingModel/MissingModel';
import { Box } from '@mui/material';
import Product from '../../@types/Product';
import { ChassisModelTypes, ChassisType } from '../../@types/ChassisType';
import useCartModelDisplay from '../../hooks/useCartModelDisplay';

export interface DefaultCartModelDisplay {
  chassisType: ChassisType | undefined,
  bodyColor: Product | undefined,
  liftKit: Product | undefined,
  wheel: Product | undefined,
  frontSeat: Product | undefined,
  rearSeat: Product | undefined
}

interface CartModelDisplayProps {
  defaults?: DefaultCartModelDisplay,
  width?: number,
  height?: number,
  alignVertical?: boolean,
  alignHorizontal?: boolean,
}

const CartModelDisplay: FC<CartModelDisplayProps> = ({
  defaults,
  width = 1000,
  height = 1000,
  alignVertical = true,
  alignHorizontal = true
}) => {
  const { chassisType } = useCartModelDisplay();
  return (
    <Box className={chassisType?.sku}
      height={height}
      width="100%"
      display={'flex'}
      flexGrow={1}
      justifyContent={alignHorizontal ? 'center' : 'flex-start'}
      alignItems={alignVertical ? 'center' : 'baseline'}>
      {(chassisType?.model === ChassisModelTypes.X4
        || defaults?.chassisType?.model === ChassisModelTypes.X4) &&
        <X4Model
          defaults={defaults}
          width={width}
          height={height} />
      }
      {(chassisType?.model === ChassisModelTypes.E4
        || defaults?.chassisType?.model === ChassisModelTypes.E4) &&
        <E4Model
          defaults={defaults}
          width={width}
          height={height} />
      }
      {(chassisType?.model === ChassisModelTypes.X6
        || defaults?.chassisType?.model === ChassisModelTypes.X6) &&
        <X6Model
          defaults={defaults}
          width={width}
          height={height} />
      }
      {((defaults?.chassisType?.model === ChassisModelTypes.X2
        || chassisType?.model === ChassisModelTypes.X2)
        || (!chassisType && !defaults?.chassisType)) &&
        <MissingModel
          width={width}
          height={height} />
      }
    </Box>
  );
}


export default CartModelDisplay;
